import { render } from "./NonFungibleFutureRewardsPayouts.vue?vue&type=template&id=f40b51fa&scoped=true"
import script from "./NonFungibleFutureRewardsPayouts.vue?vue&type=script&lang=js"
export * from "./NonFungibleFutureRewardsPayouts.vue?vue&type=script&lang=js"

import "./NonFungibleFutureRewardsPayouts.vue?vue&type=style&index=0&id=f40b51fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f40b51fa"]])

export default __exports__